import Header from "../../Containers/Header/Header";
import classes from "./Layout.module.css";

type LayoutProps = {
  children: React.ReactNode;
  header?: string;
};

const Layout = ({ children, header }: LayoutProps) => {
  return (
    <section className={classes.container}>
      <div className={classes.header}>
        <Header />
      </div>
      <div className={classes.body}>
        <h1>{header || ""}</h1>
        <div>{children}</div>
      </div>
    </section>
  );
};

export default Layout;
